module.exports = __webpack_public_path__ + "static/media/barbara5.8686b726.mp3";